<template>
    <div 
        v-if="list !== null && (!list || !list.length)"
    >
        <img class="d-block d-sm-none" :src="require('@/assets/images/pages/data-report.svg')" alt="" />
        <div class="text-center">
            {{ text }}
        </div>
	</div>
</template>


<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'EmptyResult',
  components: {
    BCard,
  },
  props: {
    text: '',
    list: null, /* defualt to hide */
  },
}
</script>

<style lang="scss" scoped>
</style>